import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import './styles.css';
import {Cta} from "../../blocks";
import ModalWindow from "../../components/modal-window";
import BodyControl from "../../components/body";
import {getComponents} from "../utilities";

/**
 *  OwnerLibraryContainer
 */
class OwnerLibraryContainer extends Component {
  
  static iconCatalogWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAhFBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fWf706wAAAAK3RSTlMALSLWiO4XEQj48ubgy6+klY+BWEME+9HCm3xybGBNKAzcuKpqST85MCkcqGTk5QAAAMhJREFUOMvt08cOwjAMgOG06d57L/bw+78fAYOE1NKaI+O/RHK+Qw4x++iGiJsw3cjqHDAKDuANbAMEJ3ncbgqLWcImkl5gHhtkLLLKPRFjq0omYU9FX7TDMpaM2MvwOX6yiMWh1TnccpR+AeN1aKN3m3mMpd0Gv8kixvTGpWOh/viLsQoQpVTsi6FaJikJaw5cs8MDATM9VB87cnzCmqIobCKj8y30POoRzyZW1kSfB4jn09t1BvcYIW1bEDF2rl3ExOSKsx/rApVXQcsPEbyfAAAAAElFTkSuQmCC';
  static iconCatalogBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAeFBMVEUAAAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBALOulEAAAAJ3RSTlMALSIT+NaI7JQG8eXLr6SBa1hMQigZ/ODRwpuOfHJgDQncuKo+OSFdjNTAAAAAxUlEQVQ4y+3TRw7DIBBAURwbDO69t1Tuf8OYTBaRTMJkmfKX8ISQBshHN8fUkfo21qYSwmAu38C+lLzYbct0eF3LiSbrCabpgsUqrzshMbQfLigcuuDbaTZjS6QhzMWJciNWsxkbON5nhQHDdu+CDxITVonsCNcxYshOAjRW6o+/GLtSxgKLo3XR7XIcLmt48/yMwMTuPXmrZtYDLhljRJPIoruncQH4ZQt82bWGK2zKng4VeMBGn7QVYFzlGABGthso+bGuhwk7oDpyF+gAAAAASUVORK5CYII=';
  static iconPdfWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAWlBMVEUAAAD19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fX19fVogrzXAAAAHXRSTlMAf4dLlvvn3/HuYhLZ0nwi9XQ6Hg3FwKprWVNFM5Cqxq4AAAC4SURBVDjL5dTHDoNADEXRR5lCCYSSnvf/v5kBCSabwbBIkbhL6ywsWTJ2Exf6PJb7LiapTjVSkjoGYg4FsTKWZ4e1JiOHtTEmiA/oFIuUCRpqhxMAC7hX7AZckEVMm2V5ENtLyRID7mXsMs8R5/IaZV0DDmtDVvLOGDFpKrzhPz63hMMzTv0cY2wjjlZhb62MvW1FPNtjCxHP9iEfarIqgYS9vUPC3t4gYG+Zb3i5V6zHDdbjCrvrBVmbLH2hjickAAAAAElFTkSuQmCC';
  static iconPdfBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsCAMAAAApWqozAAAAXVBMVEUAAAAICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAhtHcNnAAAAHnRSTlMAf0qWh/vn3vEg7mIS2dL1fXQ1DQLFwKqKa1lTPgRZ37mdAAAAu0lEQVQ4y+XUyQ6DMAxF0QclCWFomTq37/8/swkSpBswLDpI3KV1FpYsGZuJM30ey30Xk1RHix1JfemQ0DeJlUl5clhrMnJYG2Mm8R5WsdgxRk3tcAxgBreK1uOCLBKmWZZP4vRcsoTHrYxdpulxLq9RWvuEw9qQlbwz4DFpou4N//G5BTwz49DPMfpW4mgRDjaVcbCNiEd7eEDEo43lQw1WxZBwsHdIONgbBBws8xUv94rluMZyXGFzvQDdBi4JXvW1vAAAAABJRU5ErkJggg==';
  static iconBlankWhite = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAD19fWydBufAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC';
  static iconBlankBlack = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAsAQMAAAAkSshCAAAABlBMVEUAAAAICAhtdupNAAAAAXRSTlMAQObYZgAAAClJREFUGNNjoBQw////B5NqYJBBp5ibKaSARmNQDUDjcVIw9/1HoygFAI58KxZwe2obAAAAAElFTkSuQmCC';

  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    anchorPoint: PropTypes.string,
    anchorName: PropTypes.string,
    titleAndDescription: PropTypes.string,
    mbTitleAndDescription: PropTypes.string,
    notice: PropTypes.string,
    modelName: PropTypes.string,
    bodyType: PropTypes.shape({
      carId: PropTypes.string,
      generation: PropTypes.shape({
        carTypeCode: PropTypes.string,
        vehicleLibraryData: PropTypes.shape({
          vehicleLibraryCategory: PropTypes.arrayOf(PropTypes.shape({
            manualCategory: PropTypes.string,
            vehicleLibraryItems: PropTypes.arrayOf(PropTypes.shape({
              linkFunction: PropTypes.string,
              linkItem1: PropTypes.string,
              linkTarget1: PropTypes.string,
              linkIcon1: PropTypes.string,
              releaseDate: PropTypes.string,
              linkButtonTitle1: PropTypes.string,
              linkUpdatedate1: PropTypes.string,
              linkItem2: PropTypes.string,
              linkTarget2: PropTypes.string,
              linkButtonTitle2: PropTypes.string,
              linkIcon2: PropTypes.string,
              linkUpdatedate2: PropTypes.string,
              titleAndPreText: PropTypes.string,
              agreementText: PropTypes.array,
              linkAreaTitle: PropTypes.string,
              lowerDescription: PropTypes.string,
            })),
          })),
        }),
      }),
    }),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    anchorPoint: null,
    anchorName: null,
    titleAndDescription: null,
    mbTitleAndDescription: null,
    notice: null,
    modelName: null,
    bodyType: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      vehicleLibraryItem: null,
    };
  }
  
  render() {
    
    // ヘッダー表示
    const renderHeader = ()=> {
      let titleAndDescription = '';
      if (this.props.titleAndDescription && this.props.titleAndDescription !== '') {
        titleAndDescription = this.props.titleAndDescription;
      }
      let mbTitleAndDescription = '';
      if (this.props.mbTitleAndDescription && this.props.mbTitleAndDescription !== '') {
        mbTitleAndDescription = this.props.mbTitleAndDescription;
      } else {
        mbTitleAndDescription = titleAndDescription;
      }
      return (
        <div className="OwnerLibraryContainer__header Wysiwyg">
          <span className="OwnerLibraryContainer__header-pc" dangerouslySetInnerHTML={{__html: titleAndDescription}}/>
          <span className="OwnerLibraryContainer__header-mb" dangerouslySetInnerHTML={{__html: mbTitleAndDescription}}/>
        </div>
      )
    };
    
    // ライブラリ表示
    const renderLibraries = ()=> {
      
      // ライブラリ表示
      const renderLibrary = (vehicleLibraryCategory, index)=> {
        
        const getVehicleLibraryItem = ()=> {
          let vehicleLibraryItems = vehicleLibraryCategory.vehicleLibraryItems || null;
          if (vehicleLibraryItems && vehicleLibraryItems instanceof Array && 1 <= vehicleLibraryItems.length) {
            // releaseDateでソート
            vehicleLibraryItems.sort((a, b)=> {
              if(a.releaseDate > b.releaseDate) return -1;
              if(a.releaseDate < b.releaseDate) return 1;
              return 0;
            });
            return vehicleLibraryItems[0];
            // if (vehicleLibraryItems[0].linkItem1 && vehicleLibraryItems[0].linkItem1 !== '') {
            //   return vehicleLibraryItems[0];
            // }
          }
          return null;
        };
        
        const vehicleLibraryItem = getVehicleLibraryItem();
        if (vehicleLibraryItem) {
          const text = vehicleLibraryCategory.manualCategory || '';
          const href = vehicleLibraryItem.linkItem1;
          const targetBlank = (vehicleLibraryItem.linkTarget1 === 'External') ? true : false;
          let iconSrc = null;
          let linkType = 'Button';
          if (vehicleLibraryItem.linkIcon1 === 'PDF') {
            iconSrc = null;
            linkType = 'Button';
          } else if (vehicleLibraryItem.linkIcon1 === 'E-Book') {
            iconSrc = null;
            linkType = 'Button';
          } else if (vehicleLibraryItem.linkIcon1 === 'Link') {
            if (vehicleLibraryItem.linkFunction === 'Direct-Link' && targetBlank) {
              iconSrc = OwnerLibraryContainer.iconBlankWhite;
              linkType = 'Button-With-Icon';
            } else {
              iconSrc = null;
              linkType = 'Button';
            }
          }
          const handleClick = (vehicleLibraryItem.linkFunction === 'Modal-Agreement-Window') ?
            (e)=> {
              e.preventDefault();
              this.openModal(vehicleLibraryItem);
            }
            : null;
          return (
            <li key={index}>
              <Cta
                {...{
                  ctaType: 'Free',
                  href: href,
                  text: text,
                  targetBlank: targetBlank,
                  linkType: linkType,
                  color: 'Dark',
                  buttonStyle: 'Action',
                  iconSrc: iconSrc,
                  handleClick: handleClick
                }}
              />
            </li>
          )
        } else {
          return null;
        }
      };
      
      if (this.props.bodyType && this.props.bodyType.generation && this.props.bodyType.generation.vehicleLibraryData) {
        if (this.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory && this.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory instanceof Array && 1 <= this.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory.length) {
          return (
            <div className="OwnerLibraryContainer__libraries">
              <ul className="OwnerLibraryContainer__libraries__list">
                {this.props.bodyType.generation.vehicleLibraryData.vehicleLibraryCategory.map((vehicleLibraryCategory, index)=> {
                  return (
                    renderLibrary(vehicleLibraryCategory, index)
                  )
                })}
              </ul>
            </div>
          )
        }
      }
      return null;
    };
    
    // 注釈表示
    const renderNotice = ()=> {
      if (this.props.notice && this.props.notice !== '') {
        return (
          <div className="OwnerLibraryContainer__notice Wysiwyg">
            <span dangerouslySetInnerHTML={{__html: this.props.notice}}/>
          </div>
        )
      } else {
        return null;
      }
    };
    
    // モーダル内アイテム表示
    const renderModalItem = ()=> {
      if (this.state.vehicleLibraryItem) {
        return (
          <ModalItem {...{
            linkItem1: this.state.vehicleLibraryItem.linkItem1 || null,
            linkTarget1: this.state.vehicleLibraryItem.linkTarget1 || null,
            linkButtonTitle1: this.state.vehicleLibraryItem.linkButtonTitle1 || null,
            linkIcon1: this.state.vehicleLibraryItem.linkIcon1 || null,
            linkUpdatedate1: this.state.vehicleLibraryItem.linkUpdatedate1 || null,
            linkItem2: this.state.vehicleLibraryItem.linkItem2 || null,
            linkTarget2: this.state.vehicleLibraryItem.linkTarget2 || null,
            linkButtonTitle2: this.state.vehicleLibraryItem.linkButtonTitle2 || null,
            linkIcon2: this.state.vehicleLibraryItem.linkIcon2 || null,
            linkUpdatedate2: this.state.vehicleLibraryItem.linkUpdatedate2 || null,
            titleAndPreText: this.state.vehicleLibraryItem.titleAndPreText || null,
            agreementText: this.state.vehicleLibraryItem.agreementText || null,
            linkAreaTitle: this.state.vehicleLibraryItem.linkAreaTitle || null,
            lowerDescription: this.state.vehicleLibraryItem.lowerDescription || null,
          }}/>
        )
      } else {
        return null;
      }
    };
    
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
        anchorPoint={this.props.anchorPoint}
        anchorName={this.props.anchorName}
      >
        <div className="OwnerLibraryContainer">
          <div className="OwnerLibraryContainer__container">
            
            {renderHeader()}
            
            {renderLibraries()}
            
            {renderNotice()}
            
          </div>
          <ModalWindow ref="modalWindow" type="Light" onClose={this.onCloseModal}>
            
            {renderModalItem()}
            
          </ModalWindow>
        </div>
      </Wrapper>
    )
  }
  
  // モーダルウィンドウ開く
  openModal = (vehicleLibraryItem) => {
    this.setState({
      vehicleLibraryItem: vehicleLibraryItem
    });
    //
    this.refs.modalWindow.open('Light', 'Light');
    // BODYのスクロール無効化
    //BodyControl.openModal();
  };
  
  onCloseModal = () => {
    // BODYのスクロール無効化を解除
    //BodyControl.closeModal();
  };
  
}

export default OwnerLibraryContainer;

class ModalItem extends Component {
  static propTypes = {
    linkItem1: PropTypes.string,
    linkTarget1: PropTypes.string,
    linkButtonTitle1: PropTypes.string,
    linkIcon1: PropTypes.string,
    linkUpdatedate1: PropTypes.string,
    linkItem2: PropTypes.string,
    linkTarget2: PropTypes.string,
    linkButtonTitle2: PropTypes.string,
    linkIcon2: PropTypes.string,
    linkUpdatedate2: PropTypes.string,
    titleAndPreText: PropTypes.string,
    agreementText: PropTypes.array,
    linkAreaTitle: PropTypes.string,
    lowerDescription: PropTypes.string,
  };
  static defaultProps = {
    linkItem1: null,
    linkTarget1: null,
    linkButtonTitle1: null,
    linkIcon1: null,
    linkUpdatedate1: null,
    linkItem2: null,
    linkTarget2: null,
    linkButtonTitle2: null,
    linkIcon2: null,
    linkUpdatedate2: null,
    titleAndPreText: null,
    agreementText: null,
    linkAreaTitle: null,
    lowerDescription: null,
  };
  
  constructor(props) {
    super();
    this.props = props;
  }
  
  render() {
    
    const renderLink = (linkItem, linkTarget, linkButtonTitle, linkIcon, linkUpdatedate)=> {
      if (linkItem && linkItem !== '' && linkButtonTitle && linkButtonTitle !== '') {
        let iconSrc = null;
        let hoverIconSrc = null;
        let linkType = 'Button';
        const targetBlank = (linkTarget === 'External') ? true : false;
        if (linkIcon === 'PDF') {
          iconSrc = OwnerLibraryContainer.iconPdfBlack;
          hoverIconSrc = OwnerLibraryContainer.iconPdfWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'E-Book') {
          iconSrc = OwnerLibraryContainer.iconCatalogBlack;
          hoverIconSrc = OwnerLibraryContainer.iconCatalogWhite;
          linkType = 'Button-With-Icon';
        } else if (linkIcon === 'Link') {
          if (targetBlank) {
            iconSrc = OwnerLibraryContainer.iconBlankBlack;
            hoverIconSrc = OwnerLibraryContainer.iconBlankWhite;
            linkType = 'Button-With-Icon';
          } else {
            iconSrc = null;
            hoverIconSrc = null;
            linkType = 'Button';
          }
        }
        return (
          <li>
            <Cta
              {...{
                ctaType: 'Free',
                href: linkItem,
                text: linkButtonTitle,
                targetBlank: (linkTarget === 'External') ? true : false,
                linkType: linkType,
                color: 'Dark',
                buttonStyle: 'Standard',
                iconSrc: iconSrc,
                hoverIconSrc: hoverIconSrc,
              }}
            />
            {(linkUpdatedate && linkUpdatedate !== '') ? <p className="OwnerLibraryContainer__modal-item__update">更新日：{this.formatReleaseDate(linkUpdatedate)}</p> : null}
          </li>
        )
      } else {
        return null;
      }
    };
    
    return (
      <section className="OwnerLibraryContainer__modal-item">
        <div className="OwnerLibraryContainer__modal-item__container">
          {(this.props.titleAndPreText && this.props.titleAndPreText !== '') ?
            <div className="OwnerLibraryContainer__modal-item__header Wysiwyg" dangerouslySetInnerHTML={{__html: this.props.titleAndPreText}}/>
            : null}
          {(this.props.agreementText && this.props.agreementText instanceof Array && 1 <= this.props.agreementText.length) ?
            <div className="OwnerLibraryContainer__modal-item__agreement">{getComponents(this.props.agreementText)}</div>
            : null}
          <dl className="OwnerLibraryContainer__modal-item__list-dl">
            {(this.props.linkAreaTitle && this.props.linkAreaTitle !== '') ?
              <dt>{this.props.linkAreaTitle}</dt>
              : null}
            <dd>
              <ul className="OwnerLibraryContainer__modal-item__list-ul">
                {renderLink(this.props.linkItem1, this.props.linkTarget1, this.props.linkButtonTitle1, this.props.linkIcon1, this.props.linkUpdatedate1)}
                {renderLink(this.props.linkItem2, this.props.linkTarget2, this.props.linkButtonTitle2, this.props.linkIcon2, this.props.linkUpdatedate2)}
              </ul>
            </dd>
          </dl>
          {(this.props.lowerDescription && this.props.lowerDescription !== '') ?
            <div className="OwnerLibraryContainer__modal-item__description Wysiwyg" dangerouslySetInnerHTML={{__html: this.props.lowerDescription}}/>
            : null}
        </div>
      </section>
    );
  }
  
  // YYYYMMをYYYY年M月D日にフォーマト
  formatReleaseDate = (YYYYMMDD = null)=> {
    if (!YYYYMMDD || YYYYMMDD === '') return '';
    let str = String(YYYYMMDD).substr(0, 4) + '年';
    str = str + Number(String(YYYYMMDD).substr(4, 2)) + '月';
    str = str + Number(String(YYYYMMDD).substr(6, 2)) + '日';
    return str;
  };
  
}




// WEBPACK FOOTER //
// ./src/containers/owner-library-container/index.jsx